import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';
import Truncate from '../Truncate';
import Image from '../Image';

export const ElementsProjects = styled.div`
  background-color: ${props => props.theme.colors.light};
  display: flex;
  flex-direction: column;
  ${mediaqueries.greaterThan('tablet')`
    flex-direction: row;
  `};
`;

export const StyledBoxImage = styled.div`
  flex-basis: ${rem('123px')};
  overflow: hidden;
  width: 100%;
  ${mediaqueries.greaterThan('tablet')`
    max-height: ${rem('135px')};
    max-width: ${rem('360px')};
    min-width: ${rem('360px')};
  `};
`;

export const StyledImage = styled(Image)`
  img {
    width: 100%;
  }
`;

export const StyledContent = styled.div`
  padding: ${rem('10px')} ${rem('10px')} ${rem('30px')} ${rem('8px')};
  ${mediaqueries.greaterThan('mobile')`
    padding: ${rem('13px')} ${rem('10px')} 0 ${rem('18px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding: ${rem('19px')} ${rem('10px')} 0 ${rem('23px')};
  `};
`;

export const StyledTitle = styled.h3`
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${props => props.theme.fontSize.small};
  margin-top: 0;
  text-transform: uppercase;
`;

export const StyledParagraph = styled(Truncate)`
  font-size: ${props => props.theme.fontSize.small};
  line-height: ${rem('18px')};
  ${mediaqueries.greaterThan('mobile')`
    font-size:${rem('15px')};
  `};
`;

export const StyledViewProjects = styled.a`
  color: ${props => props.theme.colors.primary};
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${props => props.theme.fontSize.xsmall};
  text-transform: uppercase;
`;

export const StyledPlus = styled(Icon)`
  margin-right: ${rem('6px')};
  position: relative;
  top: ${rem('3px')};
  ${mediaqueries.greaterThan('mobile')`
    height:${rem('10px')};
    top:0;
    width:${rem('10px')};
  `};
`;
